// For Widget Style Property
export const displayProperty = (showProp) => {
    var allProperty = ['propWidth', 'propAlignment', 'ServiceFilter', 'SwitchStep'];
    allProperty.forEach(prop => {
        const element = document.querySelector('.' + prop);
        element.style.display = (showProp.includes(prop)) ? 'block' : 'none';
    }); 
}